import axios from 'axios'

const instance = axios.create({
	baseURL: 'https://digital-googl.herokuapp.com/',
})
export default instance
